const DEFAULT_ITERATIONS = 32;

export const invertMonotonic = (fn: (x: number) => number, target: number, iterations = DEFAULT_ITERATIONS): number => {
    let lower = 0;
    let upper = 1;

    for (let iteration = 0; iteration < iterations; iteration++) {
        const middle = (lower + upper) / 2;

        if (fn(middle) < target) {
            lower = middle;
        } else {
            upper = middle;
        }
    }

    return upper;
};
const DEFAULT_ITERATIONS = 32;

export const invertMonotonic = (fn: (x: number) => number, target: number, iterations = DEFAULT_ITERATIONS): number => {
    let lower = 0;
    let upper = 1;

    for (let iteration = 0; iteration < iterations; iteration++) {
        const middle = (lower + upper) / 2;

        if (fn(middle) < target) {
            lower = middle;
        } else {
            upper = middle;
        }
    }

    return upper;
};
